"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Treemap = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreTreemap_1 = require("./CoreTreemap");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var treemapDefinition = {
    chartName: "Treemap",
    bucketPropsKeys: ["measures", "viewBy", "segmentBy", "filters"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], props.measures)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.VIEW, props.viewBy),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.SEGMENT, props.segmentBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        var sortBy = getDefaultTreemapSort(buckets);
        return (_a = backend
            .withTelemetry("Treemap", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, sortBy).withDimensions(dimensions_1.treemapDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedTreemap = withChart_1.withChart(treemapDefinition)(CoreTreemap_1.CoreTreemap);
/**
 * [Treemap](https://sdk.gooddata.com/gooddata-ui/docs/treemap_component.html)
 *
 * Treemap chart presents your data hierarchically as nested rectangles.
 * Treemaps are useful for comparing proportions within the hierarchy.
 *
 * @public
 */
exports.Treemap = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.segmentBy, props.filters], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], segmentBy = _a[2], filters = _a[3];
    return (react_1.default.createElement(WrappedTreemap, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        segmentBy: segmentBy,
        filters: filters,
    })));
};
function getDefaultTreemapSort(buckets) {
    var viewBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.VIEW);
    var segmentBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.SEGMENT);
    var viewAttribute = viewBucket ? sdk_model_1.bucketAttribute(viewBucket) : undefined;
    var segmentAttribute = segmentBucket
        ? sdk_model_1.bucketAttribute(segmentBucket)
        : undefined;
    if (viewAttribute && segmentAttribute) {
        var measures = sdk_model_1.bucketsMeasures(buckets);
        return tslib_1.__spreadArrays([
            sdk_model_1.newAttributeSort(viewAttribute, "asc")
        ], measures.map(function (measure) { return sdk_model_1.newMeasureSort(measure, "desc"); }));
    }
    return [];
}
//# sourceMappingURL=Treemap.js.map